<template>
	<section>
		<div class="my-4">
		   <vue-form-generator 
		   	  v-if="modifiedSchema"
			  ref="modifiedForm"
	          :schema="modifiedSchema" 
	          :model="model"
			  />
			<div class="d-flex justify-content-center">
				<button class="btn btn-primary mx-2" @click="save()">
				{{$t('lang.button.save')}}
				</button>
			</div>
		</div>
	</section>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import VueFormGenerator from "vue-form-generator";


export default {
	props: {
	    schema: { type: Object, required: true },
	    default: { type: Object, default: () => ({}) }
	},
	components: {
		"vue-form-generator": VueFormGenerator.component,
	},
	data() {
	    return {
	    	model: this.default,
	    	modifiedSchema: null,
	    }
	},
	created(){
		if(this.default){
			this.model = this.default
		}
		this.addRequiredValidators();

	},
	methods:{
	    addRequiredValidators() {
		this.modifiedSchema = JSON.parse(JSON.stringify(this.schema));

		this.modifiedSchema.fields = this.modifiedSchema.fields.map(field => {
        	if (field.required) {
	          field.validator = VueFormGenerator.validators.required
			}
        	if (field.inputType == 'email') {
	          field.validator = VueFormGenerator.validators.email
			}
			return field;
		});
	    },
		save() {
			this.$refs.modifiedForm.validate();
			if (this.$refs.modifiedForm.errors.length > 0) {
				return;
			}else
			{
				this.$emit('save',this.model)
			}
		},
	}
}

</script>